function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { createURL } from '@sm/utils';
import { t } from '@sm/intl';
import { getHelpCenterLink } from '../../../../helpers/getHelpLink';
import COPY from './getFooterCopy';
var getAuthFooterLinks = function getAuthFooterLinks(domain, lang) {
  return [{
    title: t(COPY.ABOUT_SURVEYMONKEY),
    url: createURL('/about/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.CAREERS),
    url: createURL('/careers/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.DEVELOPERS),
    url: createURL("https://developer.".concat(domain, ".com/"), {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.PRIVACY_NOTICE),
    url: createURL('/mp/legal/privacy/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.CALIFORNIA_PRIVACY_NOTICE),
    url: createURL('/mp/legal/region-specific-privacy-statement/', {
      ut_source: 'footer'
    })
  }].concat(_toConsumableArray(lang === 'de' ? [{
    title: 'Impressum',
    url: createURL('/about/impressum/', {
      ut_source: 'footer'
    })
  }] : []), [{
    title: t(COPY.EMAIL_OPT_IN),
    url: createURL('/user/email-opt-in/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.HELP),
    url: getHelpCenterLink(lang, {
      params: {
        ut_source: 'footer'
      }
    })
  }, {
    title: t(COPY.COOKIES_NOTICE),
    url: createURL('/mp/legal/cookies/', {
      ut_source: 'footer'
    })
  }]);
};
export default getAuthFooterLinks;
//# sourceMappingURL=getAuthFooterLinks.js.map